import React, { useState, useEffect } from "react";
import DashboardHeader from "../../../components/layout/DashboardHeader";
import Sidebar from "../../../components/layout/Sidebar";
import { IoSearch } from "react-icons/io5";
import axios from "axios";
import { BASE_URL } from "../../../env";
import { MdModeEdit } from "react-icons/md";
import { Modal, Button, Form, Pagination } from "react-bootstrap";
import AddRegionModal from "./AddRegionModal";
import { IoMdAdd } from "react-icons/io";
import { useAdminAuth } from "../../auth/AdminAuthProvider";
import CustomPagination from "../../../components/ui/CustomPagination";

const AdminRegionList = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const { openSidebarToggle, toggleSidebar } = useAdminAuth();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [regions, setRegions] = useState([]);
  const [filteredRegions, setFilteredRegions] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [regionsPerPage] = useState(20);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [validationError, setValidationError] = useState("");
  const [selectedRegion, setSelectedRegion] = useState({
    id: null,
    regionName: "",
    regionCode: "",
  });

  const fetchRegions = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/api/getall/regions`);

      setRegions(response.data);
      setFilteredRegions(response.data);
      // console.log("RegionList: " + JSON.stringify(response.data));
    } catch (error) {
      console.error("Error fetching regions:", error);
    }
  };

  useEffect(() => {
    fetchRegions();
  }, []);

  useEffect(() => {
    const filtered = regions.filter((region) =>
      region.regionName.toLowerCase().includes(searchQuery.toLowerCase())
    );
    setFilteredRegions(filtered);
    setCurrentPage(1);
  }, [searchQuery, regions]);

  const OpenSidebar = () => {
    toggleSidebar();
  };

  const handleAddRegionClick = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleEditRegion = (region) => {
    setSelectedRegion(region);
    setEditModalOpen(true);
  };

  const handleCloseEditModal = () => {
    setEditModalOpen(false);
    setSelectedRegion(null);
  };

  const handleSaveChanges = async () => {
    if (!selectedRegion.regionCode || !selectedRegion.regionName) {
      setValidationError("Please Enter All Fields");
      return;
    }

    try {
      const response = await axios.put(`${BASE_URL}/api/admin/editregion`, {
        regionId: selectedRegion.id,
        regionName: selectedRegion.regionName,
        regionCode: selectedRegion.regionCode,
      });
      if (response.status === 200) {
        fetchRegions();
        handleCloseEditModal();
      } else {
        setValidationError("Error: " + response.data.error);
        console.error("Failed to update region details");
      }
    } catch (error) {
      console.error("Error updating region details:", error);
    }
  };

  const indexOfLastRegion = currentPage * regionsPerPage;
  const indexOfFirstRegion = indexOfLastRegion - regionsPerPage;
  const currentRegions = filteredRegions.slice(
    indexOfFirstRegion,
    indexOfLastRegion
  );

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const totalPages = Math.ceil(filteredRegions.length / regionsPerPage);

  return (
    <section className="master-layout">
      <div className="master-sidebar-wrapper">
        <Sidebar />
      </div>

      <div className="master-content-wrapper">
        <div className="master-header-wrapper">
          <DashboardHeader />
        </div>

        <div className="master-card-container">
          <div className="master-search-section inline-header">
            <div className="d-flex align-items-center gap-3 flex-wrap">
              <h1 className="TableHeaderText m-0">Region List</h1>
              <div className="search-input-wrapper">
                <input
                  type="text"
                  placeholder="Search by region name"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  className="search-input"
                />
                <span className="search-icon">
                  <IoSearch />
                </span>
              </div>
            </div>

            <button
              className="btn btn-addCredential m-0"
              onClick={handleAddRegionClick}
            >
              <IoMdAdd />
              Add Region
            </button>
          </div>

          <div className="master-list-section">
            <div className="master-table-wrapper table-responsive">
              <table className="mx-auto table table-striped table-list">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Region Code</th>
                    <th>Region Name</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {currentRegions.length > 0 ? (
                    currentRegions.map((region, index) => (
                      <tr key={region.id}>
                        <td>{index + 1 + (currentPage - 1) * regionsPerPage}</td>
                        <td>{region.regionCode}</td>
                        <td>{region.regionName}</td>
                        <td>
                          <button
                            className="btn btn-edit"
                            title="Edit"
                            onClick={() => handleEditRegion(region)}
                          >
                            <MdModeEdit />
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="4" className="text-center">
                        No regions found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            <div className="master-pagination-wrapper">
              <CustomPagination
                totalPages={totalPages}
                currentPage={currentPage}
                paginate={paginate}
                totalItems={filteredRegions.length}
              />
            </div>
          </div>
        </div>

        <AddRegionModal
          show={isModalOpen}
          handleClose={handleCloseModal}
          fetchRegions={fetchRegions}
        />
        {selectedRegion && (
          <Modal show={editModalOpen} onHide={handleCloseEditModal}>
            <Modal.Header closeButton>
              <Modal.Title>Edit Region</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form>
                <Form.Group controlId="editRegionCode">
                  <Form.Label className="pt-2">Region Code</Form.Label>
                  <Form.Control
                    type="text"
                    value={selectedRegion.regionCode}
                    onChange={(e) =>
                      setSelectedRegion({
                        ...selectedRegion,
                        regionCode: e.target.value,
                      })
                    }
                  />
                </Form.Group>
                <Form.Group controlId="editRegionName">
                  <Form.Label className="pt-2">Region Name</Form.Label>
                  <Form.Control
                    type="text"
                    value={selectedRegion.regionName}
                    onChange={(e) =>
                      setSelectedRegion({
                        ...selectedRegion,
                        regionName: e.target.value,
                      })
                    }
                  />
                </Form.Group>
                <h6 className="text-danger">{validationError}</h6>
              </Form>
            </Modal.Body>

            <Modal.Footer>
              <Button variant="secondary" onClick={handleCloseEditModal}>
                Close
              </Button>
              <Button variant="primary" onClick={handleSaveChanges}>
                Save Changes
              </Button>
            </Modal.Footer>
          </Modal>
        )}
      </div>
    </section>
  );
};

export default AdminRegionList;
